<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :parentData="parentData"
            ref="masterComponent"
            modalWidth="90%"
  >
    <template slot="expandedRowRender" slot-scope="{text}">
      <template v-for="ve in master.valoresExpandidos">
        {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
      </template>
    </template>
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Año')" v-bind="fiOptions">
            <a-select v-decorator="['year', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
              <a-select-option v-for="year_ in years" :key="year_">
                {{ year_ }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Mes')" v-bind="fiOptions">
            <a-select v-decorator="['month', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
              <a-select-option v-for="month_ in months_name" :key="month_.value">
                {{ month_.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Periodo')"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :decorator="['period', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="period_request">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Porcentaje')">
            <a-input-number style="width: 100%;"
                            v-decorator="['cc_percent', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_ID_PROYECTO')">
            <a-input
              v-decorator="['id_prj', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level1')">
            <a-input style="width: 100%;"
                     v-decorator="['level1', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level2')">
            <a-input style="width: 100%;"
                     v-decorator="['level2', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level3')">
            <a-input style="width: 100%;"
                     v-decorator="['level3', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level4')">
            <a-input style="width: 100%;"
                     v-decorator="['level4', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level5')">
            <a-input style="width: 100%;"
                     v-decorator="['level5', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level6')">
            <a-input style="width: 100%;"
                     v-decorator="['level6', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level7')">
            <a-input style="width: 100%;"
                     v-decorator="['level7', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level8')">
            <a-input style="width: 100%;"
                     v-decorator="['level8', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level9')">
            <a-input style="width: 100%;"
                     v-decorator="['level9', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Level10')">
            <a-input style="width: 100%;"
                     v-decorator="['level10', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>
<script>
  export default {
    props: ['empleadoseleccionado', 'endpoint'],
    data () {
      return {
        centro_cc: null,
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        colOptions: {xs: 24, sm: 6},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: this.endpoint,
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month', sorter: true},
              {title: 'Periodo', dataIndex: 'h_period', sorter: true},
              {title: 'Porcentaje', dataIndex: 'cc_percent', sorter: true},
              {title: 'Level1', dataIndex: 'level1', sorter: true},
              {title: 'Level2', dataIndex: 'level2', sorter: true},
              {title: 'Level3', dataIndex: 'level3', sorter: true},
              {title: 'Level4', dataIndex: 'level4', sorter: true},
              {title: 'Level5', dataIndex: 'level5', sorter: true},
              {title: 'Level6', dataIndex: 'level6', sorter: true},
              {title: 'Level7', dataIndex: 'level7', sorter: true},
              {title: 'Level8', dataIndex: 'level8', sorter: true},
              {title: 'Level9', dataIndex: 'level9', sorter: true},
              {title: 'Level10', dataIndex: 'level10', sorter: true},
              {title: 'Id Proyecto', dataIndex: 'id_prj', sorter: true},
              {title: 'Proyecto', dataIndex: 'nombre_prj', sorter: true}
            ]
          }
        }
      }
    },
    mounted () {
      this.yearsSelect()
    },
    methods: {
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 4); i++) {
          this.years.push(i)
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/CentroDeCostoOracle.vue